import {computed, decorate, observable} from 'mobx';
import {faListAlt} from '@fortawesome/free-solid-svg-icons';
import {BaseModel} from './base';
import i18n from '../i18n/i18n';

export class CustomProperty extends BaseModel {
  static faIcon = faListAlt;

  searchableProperties = ['typeFormatted', 'key', 'label'];

  get typeFormatted() {
    return i18n.t(`customProperty.types.${this.type}`);
  }
}

decorate(CustomProperty, {
  id: observable,
  type: observable,
  key: observable,
  label: observable,
  required: observable,
  typeFormatted: computed,
  sortOrder: observable,
  createdAt: observable,
  createdBy: observable,
  updatedAt: observable,
  updatedBy: observable,
});

/**
 * custom property translations:
 * t('customProperty.types.COMPONENT')
 * t('customProperty.types.INSPECTION_TASK')
 * t('customProperty.types.MATERIAL')
 * t('customProperty.types.ORDER')
 * t('customProperty.types.OPERATION')
 * t('customProperty.types.OPERATION_STATE')
 * t('customProperty.types.USER')
 * t('customProperty.types.WORKFLOW')
 * t('customProperty.types.WORKPLACE')
 * t('customProperty.types.WORKPLACE_STATE')
 * t('customProperty.types.BATCH')
 */
export const CustomPropertyTypes = Object.freeze({
  Component: 'COMPONENT',
  InspectionTask: 'INSPECTION_TASK',
  Material: 'MATERIAL',
  Operation: 'OPERATION',
  OperationState: 'OPERATION_STATE',
  Order: 'ORDER',
  User: 'USER',
  Workflow: 'WORKFLOW',
  Workplace: 'WORKPLACE',
  WorkplaceState: 'WORKPLACE_STATE',
  Batch: 'BATCH',
});
